import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "../../context";

export const JiffyContainer = styled.div<{ rooTheme?: Theme }>`
  ${tw`lg:px-2.5`}
  background: ${({ rooTheme }) => (rooTheme !== "dark" ? "white" : "#000")};
`;

export const JiffyContentController = styled.div`
  ${tw`font-clash flex w-full flex-col justify-center h-[425px] lg:h-[700px]`}
`;

export const JiffyStartedHeading = styled.h2<{ rooTheme?: Theme }>`
  ${tw`font-[600] text-2xl md:text-[40px] text-center`}
  color: ${({ rooTheme }) => (rooTheme !== "dark" ? "#202125" : "white")};
`;

export const JiffyStartedParagraph = styled.p<{ rooTheme?: Theme }>`
  ${tw`font-[400] pt-5 md:pb-4 text-[14px] md:text-base w-[90%]  md:w-full text-center`}
  color: ${({ rooTheme }) => (rooTheme !== "dark" ? "#202125" : "white")};

  @media screen and (max-width: 768px) {
    ${tw`text-center font-[400]`}
  }
`;

export const JiffyImage = styled.img``;
